export default __webpack_public_path__ + "static/media/TDS.7f0cd1a8.jfif";